// src/pages/Professeurs.js - VERSION RICH UI
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { supabase } from '../supabaseClient';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=DM+Sans:wght@300;400;500;600&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .profs-page {
    min-height: 100vh;
    background: #f7f4ef;
    font-family: 'DM Sans', sans-serif;
    color: #1a1a1a;
  }

  /* ── HERO ── */
  .profs-hero {
    background: linear-gradient(135deg, #0b1f17 0%, #0f3d3d 100%);
    padding: 52px 40px 44px;
    position: relative;
    overflow: hidden;
  }
  .profs-hero::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 320px; height: 320px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(212,163,89,0.18) 0%, transparent 70%);
    pointer-events: none;
  }
  .profs-hero::after {
    content: 'ع';
    position: absolute;
    bottom: -20px; left: 32px;
    font-size: 160px;
    color: rgba(255,255,255,0.04);
    font-family: 'Marcellus', serif;
    pointer-events: none;
    line-height: 1;
  }
  .hero-inner {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }
  .hero-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(212,163,89,0.15);
    border: 1px solid rgba(212,163,89,0.35);
    color: #d4a359;
    padding: 5px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 18px;
  }
  .hero-title {
    font-family: 'Marcellus', serif;
    font-size: clamp(28px, 4vw, 42px);
    color: #fff;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 12px;
  }
  .hero-title span { color: #d4a359; }
  .hero-sub {
    color: rgba(255,255,255,0.58);
    font-size: 15px;
    max-width: 480px;
    line-height: 1.6;
    margin-bottom: 28px;
  }
  .hero-stats {
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
  }
  .hero-stat {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .hero-stat-num {
    font-family: 'Marcellus', serif;
    font-size: 26px;
    font-weight: 700;
    color: #d4a359;
    line-height: 1;
  }
  .hero-stat-label {
    font-size: 11px;
    color: rgba(255,255,255,0.45);
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  /* ── SEARCH BAR ── */
  .search-bar-wrap {
    background: #fff;
    border-bottom: 1px solid #e8e2d9;
    padding: 16px 40px;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  }
  .search-bar-inner {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .search-input-wrap {
    flex: 1;
    position: relative;
  }
  .search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 16px;
  }
  .search-input {
    width: 100%;
    padding: 11px 16px 11px 42px;
    border: 1.5px solid #e0d9ce;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    color: #1a1a1a;
    background: #faf9f7;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
  }
  .search-input:focus {
    border-color: #0b1f17;
    box-shadow: 0 0 0 3px rgba(26,39,68,0.08);
    background: #fff;
  }
  .search-input::placeholder { color: #bbb; }
  .results-badge {
    background: #0b1f17;
    color: #fff;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }
  .results-badge span { color: #d4a359; }
  .btn-reset-all {
    padding: 8px 14px;
    border: 1.5px solid #e0d9ce;
    border-radius: 8px;
    background: #fff;
    color: #666;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
  }
  .btn-reset-all:hover { border-color: #c0392b; color: #c0392b; }

  /* ── LAYOUT ── */
  .profs-layout {
    max-width: 1280px;
    margin: 0 auto;
    padding: 32px 40px;
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 28px;
    align-items: start;
  }

  /* ── SIDEBAR ── */
  .filters-sidebar {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e8e2d9;
    overflow: hidden;
    position: sticky;
    top: 74px;
  }
  .sidebar-header {
    padding: 18px 20px;
    border-bottom: 1px solid #f0ebe2;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .sidebar-title {
    font-weight: 700;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #0b1f17;
  }
  .filter-group {
    padding: 18px 20px;
    border-bottom: 1px solid #f0ebe2;
  }
  .filter-group:last-child { border-bottom: none; }
  .filter-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #999;
    margin-bottom: 10px;
    display: block;
  }
  .filter-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .filter-tag {
    padding: 5px 12px;
    border-radius: 20px;
    border: 1.5px solid #e2e8f0;
    background: #fff;
    color: #4a5568;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
  }
  .filter-tag:hover {
    border-color: #065f46;
    color: #065f46;
  }
  .filter-tag.active {
    background: #065f46;
    border-color: #065f46;
    color: #fff;
    font-weight: 600;
  }
  .filter-select {
    width: 100%;
    padding: 9px 12px;
    border: 1.5px solid #e0d9ce;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    color: #1a1a1a;
    background: #faf9f7;
    cursor: pointer;
    outline: none;
    transition: border-color 0.2s;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23999'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 32px;
  }
  .filter-select:focus { border-color: #0b1f17; }

  /* Prix slider */
  .price-range-wrap { margin-top: 4px; }
  .price-labels {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .price-val {
    background: #f0ebe2;
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #0b1f17;
  }
  .price-slider {
    width: 100%;
    accent-color: #0b1f17;
    cursor: pointer;
  }

  /* Toggle disponible */
  .toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  .toggle-text {
    font-size: 13px;
    color: #333;
    font-weight: 500;
  }
  .toggle-switch {
    width: 40px;
    height: 22px;
    background: #e0d9ce;
    border-radius: 11px;
    position: relative;
    transition: background 0.2s;
    flex-shrink: 0;
  }
  .toggle-switch.on { background: #0b1f17; }
  .toggle-switch::after {
    content: '';
    position: absolute;
    top: 3px; left: 3px;
    width: 16px; height: 16px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.2s;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  }
  .toggle-switch.on::after { transform: translateX(18px); }

  /* Rating pills */
  .rating-pills {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .rating-pill {
    padding: 7px 12px;
    border: 1.5px solid #e0d9ce;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s;
    background: #faf9f7;
    color: #555;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .rating-pill:hover { border-color: #0b1f17; color: #0b1f17; }
  .rating-pill.active { border-color: #0b1f17; background: #0b1f17; color: #fff; }

  /* Sort */
  .sort-tabs {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .sort-tab {
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s;
    color: #666;
    border: none;
    background: none;
    text-align: left;
    font-family: 'DM Sans', sans-serif;
  }
  .sort-tab:hover { background: #f0ebe2; color: #0b1f17; }
  .sort-tab.active { background: #0b1f17; color: #fff; }

  /* ── GRID ── */
  .profs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }

  /* ── CARD ── */
  .prof-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e8e2d9;
    overflow: hidden;
    transition: transform 0.25s, box-shadow 0.25s;
    cursor: pointer;
    position: relative;
  }
  .prof-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 40px rgba(0,0,0,0.10);
  }

  .card-top {
    position: relative;
    height: 160px;
    background: linear-gradient(135deg, #0b1f17 0%, #0f3d3d 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .card-top::after {
    content: '';
    position: absolute;
    bottom: -30px; right: -30px;
    width: 120px; height: 120px;
    border-radius: 50%;
    background: rgba(212,163,89,0.12);
  }
  .card-avatar {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    object-position: center top;
    border-radius: 0;
    border: none;
    z-index: 1;
    image-orientation: from-image;
  }
  .card-avatar-overlay {
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 50%;
    background: linear-gradient(to top, rgba(0,0,0,0.45), transparent);
    z-index: 2;
  }
  .card-avatar-placeholder {
    width: 80px; height: 80px;
    border-radius: 50%;
    background: rgba(255,255,255,0.12);
    border: 3px solid rgba(255,255,255,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    position: relative;
    z-index: 1;
  }
  .avatar-initials {
    font-family: 'Marcellus', serif;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
  }

  .card-badges {
    position: absolute;
    top: 10px;
    left: 10px;
    display: flex;
    z-index: 10;
    flex-direction: column;
    gap: 5px;
    z-index: 10;
  }
  .badge-pill {
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    backdrop-filter: blur(4px);
  }
  .badge-recommended { background: rgba(212,163,89,0.9); color: #fff; }
  .badge-popular { background: rgba(231,76,60,0.85); color: #fff; }
  .badge-verified {
    background: rgba(16,185,129,0.2);
    color: #10b981;
    border: 1px solid rgba(16,185,129,0.4);
  }
  .badge-new { background: rgba(39,174,96,0.85); color: #fff; }

  .online-dot {
    z-index: 10;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 10px; height: 10px;
    background: #27ae60;
    border-radius: 50%;
    border: 2px solid #fff;
    z-index: 2;
    box-shadow: 0 0 0 3px rgba(39,174,96,0.3);
    animation: pulse 2s infinite;
  }
  @keyframes pulse {
    0%, 100% { box-shadow: 0 0 0 3px rgba(39,174,96,0.3); }
    50% { box-shadow: 0 0 0 6px rgba(39,174,96,0.1); }
  }

  .video-indicator {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: rgba(0,0,0,0.5);
    color: #fff;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 600;
    backdrop-filter: blur(4px);
    z-index: 2;
  }

  .card-body {
    padding: 18px 18px 14px;
  }
  .card-name {
    font-family: 'Marcellus', serif;
    font-size: 17px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 4px;
    line-height: 1.2;
  }
  .card-location {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .card-rating-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }
  .stars-row {
    display: flex;
    gap: 1px;
  }
  .star-icon {
    font-size: 12px;
    color: #e0d9ce;
  }
  .star-icon.filled { color: #f39c12; }
  .rating-num {
    font-size: 13px;
    font-weight: 700;
    color: #1a1a1a;
  }
  .rating-count {
    font-size: 11px;
    color: #aaa;
  }
  .exp-tag {
    margin-left: auto;
    font-size: 11px;
    color: #666;
    background: #f7f4ef;
    padding: 2px 8px;
    border-radius: 5px;
    font-weight: 600;
  }

  .card-specs {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 10px;
  }
  .spec-tag {
    padding: 4px 8px;
    background: #f0ebe2;
    color: #5a4a3a;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
  }
  .spec-tag.lang {
    background: #e8f0fe;
    color: #1a56bb;
  }

  .card-bio {
    font-size: 12px;
    color: #777;
    line-height: 1.5;
    margin-bottom: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .card-footer {
    padding: 12px 18px;
    border-top: 1px solid #f0ebe2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .price-block {}
  .price-main {
    font-family: 'Marcellus', serif;
    font-size: 20px;
    font-weight: 700;
    color: #0b1f17;
    line-height: 1;
  }
  .price-sub {
    font-size: 10px;
    color: #aaa;
    margin-top: 1px;
  }
  .price-alt {
    font-size: 11px;
    color: #bbb;
    margin-top: 2px;
  }

  .card-actions {
    display: flex;
    gap: 7px;
  }
  .btn-book {
    padding: 9px 16px;
    background: #0b1f17;
    color: #fff;
    border: none;
    border-radius: 9px;
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: background 0.2s, transform 0.15s;
    white-space: nowrap;
  }
  .btn-book:hover { background: #0f3d3d; transform: translateY(-1px); }
  .btn-profile {
    padding: 9px 12px;
    border: 1.5px solid #e0d9ce;
    border-radius: 9px;
    background: transparent;
    color: #666;
    font-size: 13px;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    transition: all 0.2s;
  }
  .btn-profile:hover { border-color: #0b1f17; color: #0b1f17; }

  /* ── EMPTY ── */
  .no-results {
    grid-column: 1 / -1;
    text-align: center;
    padding: 60px 20px;
  }
  .no-results-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.4;
  }
  .no-results h3 {
    font-family: 'Marcellus', serif;
    font-size: 22px;
    color: #0b1f17;
    margin-bottom: 8px;
  }
  .no-results p { color: #999; font-size: 14px; }

  /* ── LOADING ── */
  .loading-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    gap: 16px;
  }
  .spinner-ring {
    width: 44px; height: 44px;
    border: 3px solid #e0d9ce;
    border-top-color: #0b1f17;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* ── RESPONSIVE ── */
  @media (max-width: 900px) {
    .profs-hero { padding: 36px 20px 32px; }
    .search-bar-wrap { padding: 12px 20px; }
    .profs-layout {
      grid-template-columns: 1fr;
      padding: 20px;
      gap: 20px;
    }
    .filters-sidebar { position: static; }
    .filter-group { padding: 14px 16px; }
    .hero-stats { gap: 20px; }
  }
`;

// ── helpers ──────────────────────────────────────────────
const getInitials = (nom = '') => {
  const parts = nom.trim().split(' ');
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : nom.slice(0, 2).toUpperCase();
};

const getLastSeen = (ts) => {
  if (!ts) return null;
  const diff = Math.round((Date.now() - new Date(ts)) / 60000);
  if (diff < 5) return 'En ligne';
  if (diff < 60) return `Il y a ${diff} min`;
  if (diff < 1440) return `Il y a ${Math.round(diff / 60)}h`;
  return `Il y a ${Math.round(diff / 1440)}j`;
};

const Stars = ({ rating = 0 }) => (
  <div className="stars-row">
    {[1, 2, 3, 4, 5].map(i => (
      <span key={i} className={`star-icon ${i <= Math.round(rating) ? 'filled' : ''}`}>★</span>
    ))}
  </div>
);

const getBadge = (prof) => {
  const r = prof.rating_moyen || 0;
  const n = prof.nombre_avis || 0;
  if (r >= 4.8 && n >= 5) return { label: '🏆 Top', cls: 'badge-recommended' };
  if (r >= 4.5 && n >= 3) return { label: '🔥 Populaire', cls: 'badge-popular' };
  if (n === 0) return { label: '🆕 Nouveau', cls: 'badge-new' };
  if (prof.statut_profil === 'valide') return { label: '✅ Vérifié', cls: 'badge-verified' };
  return { label: '✅ Vérifié', cls: 'badge-verified' };
};

// ── composant ────────────────────────────────────────────
export default function Professeurs() {
  const [professors, setProfessors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // filtres
  const [search, setSearch] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [langueEnseignee, setLangueEnseignee] = useState('');
  const [sousFiltre, setSousFiltre] = useState('');
  const [langueComm, setLangueComm] = useState('');
  const [cibleEleve, setCibleEleve] = useState('');
  const [country, setCountry] = useState('');
  const [maxPrice, setMaxPrice] = useState(100);
  const [minRating, setMinRating] = useState(0);
  const [onlyAvailable, setOnlyAvailable] = useState(false);
  const [sortBy, setSortBy] = useState('rating');

  // chargement
  useEffect(() => {
    (async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) { setError('Veuillez vous connecter'); return; }
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/profs`, {
          headers: { Authorization: `Bearer ${session.access_token}` }
        });
        if (res.data.success) setProfessors(res.data.profs);
      } catch (e) {
        setError('Erreur lors du chargement des professeurs');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // options dynamiques
  const allSpecialties = [...new Set(professors.flatMap(p => p.specialites || [p.specialite]).filter(Boolean))];
  const allLanguages = [...new Set(professors.flatMap(p => p.langues_parlees || []).filter(Boolean))];
  const allLangComm = [...new Set(professors.flatMap(p => p.langues_communication || []).filter(Boolean))];
  const allCountries = [...new Set(professors.map(p => p.pays_origine).filter(Boolean))];
  const globalMaxPrice = Math.max(100, ...professors.map(p => p.prix_30min || 0));

  // filtrage
  const filtered = professors
    .filter(p => {
      if (search) {
        const q = search.toLowerCase();
        if (!p.nom?.toLowerCase().includes(q) && !p.bio?.toLowerCase().includes(q)) return false;
      }
      if (langueEnseignee) {
        const spec = (p.specialites || []).map(s => s.toLowerCase()).join(' ');
        const mappings = {
          'fusha': ['fusha', 'littéraire', 'litteraire'],
          'coran': ['coran', 'coranique', 'tajwid'],
          'darija': ['darija', 'dialecte', 'dialectal', 'égyptien', 'egyptien', 'golfe', 'levantin', 'tunisi', 'algéri', 'alger', 'marocain', 'mauritanien', 'irakien'],
          'amazighe': ['amazigh', 'tarifit', 'tachelhit', 'tamazight', 'kabyle', 'chaoui', 'mozabite', 'touareg'],
          'grammaire': ['grammaire', 'syntaxe'],
          'conversation': ['conversation', 'culture', 'affaires'],
          'calligraphie': ['calligraphie', 'calligraph', 'écriture', 'ecriture'],
        };
        const terms = mappings[langueEnseignee] || [langueEnseignee.toLowerCase()];
        if (!terms.some(t => spec.includes(t))) return false;
      }
      if (sousFiltre) {
        const spec = (p.specialites || []).map(s => s.toLowerCase()).join(' ');
        if (!spec.includes(sousFiltre.toLowerCase())) return false;
      }
      if (langueComm && !(p.langues_communication || p.langues_parlees || []).some(l => l.toLowerCase().includes(langueComm.toLowerCase()))) return false;
      if (country && p.pays_origine !== country) return false;
      if (maxPrice < globalMaxPrice && (p.prix_30min || 0) > maxPrice) return false;
      if (minRating > 0 && (p.rating_moyen || 0) < minRating) return false;
      if (onlyAvailable && !p.disponible_maintenant && !p.is_online) return false;
      return true;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'price_asc': return (a.prix_30min || 0) - (b.prix_30min || 0);
        case 'price_desc': return (b.prix_30min || 0) - (a.prix_30min || 0);
        case 'experience': return (b.experience_annees || 1) - (a.experience_annees || 1);
        case 'reviews': return (b.nombre_avis || 0) - (a.nombre_avis || 0);
        default: return (b.rating_moyen || 0) - (a.rating_moyen || 0);
      }
    });

  const resetFilters = () => {
    setSearch(''); setSpecialty(''); setLangueEnseignee(''); setLangueComm(''); setSousFiltre('');
    setCountry(''); setMaxPrice(globalMaxPrice);
    setMinRating(0); setOnlyAvailable(false); setSortBy('rating');
  };

  const hasFilters = search || specialty || langueEnseignee || sousFiltre || langueComm || country || minRating > 0 || onlyAvailable;

  // stats hero
  const topRated = professors.filter(p => (p.rating_moyen || 0) >= 4.5).length;
  const online = professors.filter(p => p.disponible_maintenant || p.is_online).length;

  if (loading) return (
    <div className="profs-page">
      <style>{styles}</style>
      <div className="loading-wrap">
        <div className="spinner-ring" />
        <span style={{ color: '#999', fontSize: 14 }}>Chargement des professeurs…</span>
      </div>
    </div>
  );

  if (error) return (
    <div className="profs-page" style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh' }}>
      <style>{styles}</style>
      <div style={{ textAlign:'center' }}>
        <div style={{ fontSize:40, marginBottom:12 }}>❌</div>
        <p style={{ color:'#666' }}>{error}</p>
      </div>
    </div>
  );

  return (
    <div className="profs-page">
      <style>{styles}</style>

      {/* HERO */}
      <div className="profs-hero">
        <div className="hero-inner">
          <div className="hero-eyebrow">✦ Professeurs certifiés</div>
          <h1 className="hero-title">
            Trouvez votre prof<br />
            <span>d'arabe idéal</span>
          </h1>
          <p className="hero-sub">
            Des natifs passionnés, disponibles en ligne pour vous accompagner à votre rythme.
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-num">{professors.length}</div>
              <div className="hero-stat-label">Professeurs</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-num">{topRated}</div>
              <div className="hero-stat-label">Excellents 4.5★+</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-num">{online}</div>
              <div className="hero-stat-label">En ligne</div>
            </div>
          </div>
        </div>
      </div>

      {/* SEARCH BAR */}
      <div className="search-bar-wrap">
        <div className="search-bar-inner">
          <div className="search-input-wrap">
            <span className="search-icon">🔍</span>
            <input
              className="search-input"
              type="text"
              placeholder="Rechercher par nom, spécialité, bio…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <div className="results-badge">
            <span>{filtered.length}</span> prof{filtered.length !== 1 ? 's' : ''} trouvé{filtered.length !== 1 ? 's' : ''}
          </div>
          {hasFilters && (
            <button className="btn-reset-all" onClick={resetFilters}>
              ✕ Réinitialiser
            </button>
          )}
        </div>
      </div>

      {/* MAIN LAYOUT */}
      <div className="profs-layout">

        {/* SIDEBAR */}
        <aside className="filters-sidebar">
          <div className="sidebar-header">
            <span className="sidebar-title">⚙ Filtres</span>
          </div>

          {/* Langue enseignée */}
          <div className="filter-group">
            <span className="filter-label">Langue enseignée</span>
            <div className="filter-tags">
              {[
                { val: '', label: 'Toutes' },
                { val: 'fusha', label: '📖 Arabe littéraire' },
                { val: 'coran', label: '🕌 Coran & Tajwid' },
                { val: 'darija', label: '💬 Darija' },
                { val: 'amazighe', label: '⵿ Amazighe' },
                { val: 'grammaire', label: '📝 Grammaire' },
                { val: 'conversation', label: '🗣 Conversation' },
                { val: 'calligraphie', label: '✍️ Calligraphie' },
              ].map(opt => (
                <button
                  key={opt.val}
                  className={`filter-tag ${langueEnseignee === opt.val ? 'active' : ''}`}
                  onClick={() => { setLangueEnseignee(opt.val); setSousFiltre(''); }}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          {/* Sous-filtres Darija */}
          {langueEnseignee === 'darija' && (
            <div className="filter-group">
              <span className="filter-label">Variante Darija</span>
              <div className="filter-tags">
                {[
                  { val: '', label: 'Toutes' },
                  { val: 'marocain', label: '🇲🇦 Marocaine' },
                  { val: 'algéri', label: '🇩🇿 Algérienne' },
                  { val: 'tunisi', label: '🇹🇳 Tunisienne' },
                  { val: 'libyen', label: '🇱🇾 Libyenne' },
                  { val: 'égyptien', label: '🇪🇬 Égyptien' },
                  { val: 'levantin', label: '🌙 Levantin' },
                  { val: 'golfe', label: '🌴 Golfe' },
                  { val: 'irakien', label: '🇮🇶 Irakien' },
                  { val: 'mauritanien', label: '🇲🇷 Mauritanien' },
                ].map(opt => (
                  <button
                    key={opt.val}
                    className={`filter-tag ${sousFiltre === opt.val ? 'active' : ''}`}
                    onClick={() => setSousFiltre(opt.val)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Sous-filtres Amazighe */}
          {langueEnseignee === 'amazighe' && (
            <div className="filter-group">
              <span className="filter-label">Variante Amazighe</span>
              <div className="filter-tags">
                {[
                  { val: '', label: 'Toutes' },
                  { val: 'tarifit', label: 'Tarifit (Rif)' },
                  { val: 'tachelhit', label: 'Tachelhit (Souss)' },
                  { val: 'tamazight', label: 'Tamazight (Atlas)' },
                  { val: 'kabyle', label: 'Kabyle' },
                  { val: 'chaoui', label: 'Chaoui' },
                  { val: 'mozabite', label: 'Mozabite' },
                  { val: 'touareg', label: 'Touareg' },
                ].map(opt => (
                  <button
                    key={opt.val}
                    className={`filter-tag ${sousFiltre === opt.val ? 'active' : ''}`}
                    onClick={() => setSousFiltre(opt.val)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Langue de communication */}
          <div className="filter-group">
            <span className="filter-label">Langue de communication</span>
            <select className="filter-select" value={langueComm} onChange={e => setLangueComm(e.target.value)}>
              <option value="">Toutes</option>
              {allLangComm.map(l => <option key={l} value={l}>{l}</option>)}
            </select>
          </div>

          {/* Pays */}
          <div className="filter-group">
            <span className="filter-label">Pays d'origine</span>
            <select className="filter-select" value={country} onChange={e => setCountry(e.target.value)}>
              <option value="">Tous</option>
              {allCountries.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>

          {/* Prix masqué temporairement - tarif fixe FirstArabic */}
          <div className="filter-group" style={{display:'none'}}>
            <span className="filter-label">Prix max / 30min</span>
            <div className="price-range-wrap">
              <div className="price-labels">
                <span className="price-val">0 €</span>
                <span className="price-val">{maxPrice} €</span>
              </div>
              <input
                type="range"
                className="price-slider"
                min={0}
                max={globalMaxPrice}
                value={maxPrice}
                onChange={e => setMaxPrice(Number(e.target.value))}
              />
            </div>
          </div>

          {/* Note minimum */}
          <div className="filter-group">
            <span className="filter-label">Note minimum</span>
            <div className="rating-pills">
              {[0, 3.5, 4.0, 4.5].map(r => (
                <div
                  key={r}
                  className={`rating-pill ${minRating === r ? 'active' : ''}`}
                  onClick={() => setMinRating(r)}
                >
                  {r === 0 ? 'Toutes notes' : `${r}★ et plus`}
                </div>
              ))}
            </div>
          </div>

          {/* Disponibles maintenant */}
          <div className="filter-group">
            <div className="toggle-row" onClick={() => setOnlyAvailable(!onlyAvailable)}>
              <span className="toggle-text">🟢 Disponibles maintenant</span>
              <div className={`toggle-switch ${onlyAvailable ? 'on' : ''}`} />
            </div>
          </div>

          {/* Tri */}
          <div className="filter-group">
            <span className="filter-label">Trier par</span>
            <div className="sort-tabs">
              {[
                { val: 'rating', label: '⭐ Meilleure note' },
                { val: 'reviews', label: '💬 Plus d\'avis' },
                { val: 'experience', label: '🏆 Expérience' },
        
              ].map(opt => (
                <button
                  key={opt.val}
                  className={`sort-tab ${sortBy === opt.val ? 'active' : ''}`}
                  onClick={() => setSortBy(opt.val)}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        </aside>

        {/* GRILLE */}
        <div className="profs-grid">
          {filtered.length === 0 ? (
            <div className="no-results">
              <div className="no-results-icon">🔍</div>
              <h3>Aucun professeur trouvé</h3>
              <p>Essayez d'ajuster vos filtres.</p>
            </div>
          ) : filtered.map(prof => {
            const badge = getBadge(prof);
            const isOnline = prof.disponible_maintenant || prof.is_online;
            const lastSeen = getLastSeen(prof.derniere_connexion);
            const nom = prof.prenom ? `${prof.prenom} ${prof.nom}` : prof.nom;

            return (
              <div className="prof-card" key={prof.id}>
                {/* TOP */}
                <div className="card-top">
                  {badge && (
                    <div className="card-badges">
                      <span className={`badge-pill ${badge.cls}`}>{badge.label}</span>
                    </div>
                  )}
                  {isOnline && <div className="online-dot" />}
                  {prof.video_intro_url && <div className="video-indicator">🎥 Vidéo</div>}

                  {prof.photo_url ? (
                    <>
                      <img className="card-avatar" src={prof.photo_url} alt={nom} />
                      <div className="card-avatar-overlay" />
                    </>
                  ) : (
                    <div className="card-avatar-placeholder">
                      <span className="avatar-initials">{getInitials(prof.nom)}</span>
                    </div>
                  )}
                </div>

                {/* BODY */}
                <div className="card-body">
                  <div className="card-name">{nom}</div>
                  {(prof.pays_origine || lastSeen) && (
                    <div className="card-location">
                      {prof.pays_origine && <span>📍 {prof.pays_origine}</span>}
                      {lastSeen && prof.pays_origine && <span style={{color:'#ddd'}}>·</span>}
                      {lastSeen && <span style={{color: isOnline ? '#27ae60' : '#aaa'}}>{lastSeen}</span>}
                    </div>
                  )}

                  {/* Rating */}
                  <div className="card-rating-row">
                    <Stars rating={prof.rating_moyen || 0} />
                    <span className="rating-num">{(prof.rating_moyen || 0).toFixed(1)}</span>
                    <span className="rating-count">({prof.nombre_avis || 0})</span>
                    {prof.experience_annees && (
                      <span className="exp-tag">{prof.experience_annees}+ ans</span>
                    )}
                  </div>

                  {/* Tags */}
                  <div className="card-specs">
                    {(prof.specialites || [prof.specialite]).filter(Boolean).slice(0, 2).map((s, i) => (
                      <span key={i} className="spec-tag">{s}</span>
                    ))}
                    {(prof.langues_parlees || []).slice(0, 2).map((l, i) => (
                      <span key={i} className="spec-tag lang">{l}</span>
                    ))}
                  </div>

                  {/* Bio */}
                  {prof.bio && <p className="card-bio">{prof.bio}</p>}
                </div>

                {/* FOOTER */}
                <div className="card-footer">
                  <div className="price-block">
                    {/* Prix masqué temporairement - tarif fixe FirstArabic */}
                    {false && prof.prix_30min ? (
                      <>
                        <div className="price-main">{prof.prix_30min}€</div>
                        <div className="price-sub">/ 30 minutes</div>
                        {prof.prix_60min && (
                          <div className="price-alt">{prof.prix_60min}€ / 60 min</div>
                        )}
                      </>
                    ) : (
                      <div className="price-main" style={{fontSize:14, color:'#aaa'}}>Sur demande</div>
                    )}
                  </div>
                  <div className="card-actions">
                    <Link to={`/professeur/${prof.id}`} className="btn-profile" title="Voir le profil">👁</Link>
                    <Link to={`/professeur/${prof.id}`} className="btn-book">Réserver</Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
